import {
  SET_INVESTMENT_INFORMATION,
  SET_SELECTED_INVESTMENT_INFORMATION,
  SET_INVESTMENT_ENTITY_INFORMATION,
  SET_INVESTMENT_TYPE_INFORMATION,
  SET_PROJECTION_MODEL,
  SET_PROJECTION_API_RESPONSE,
  SET_INVESTMENT_CHART_MODEL,
  SET_COMPARE_INVESTMENTS_INFO,
} from "../../../helpers/vuex-constants";

export default {
  [SET_INVESTMENT_INFORMATION](state, payload) {
    state.investmentdata = payload;
  },
  [SET_SELECTED_INVESTMENT_INFORMATION](state, payload) {
    state.selectedInvestment = payload;
  },
  [SET_INVESTMENT_TYPE_INFORMATION](state, payload) {
    state.investmentType = payload;
  },
  [SET_INVESTMENT_ENTITY_INFORMATION](state, payload) {
    state.investmentEntitiesInfo = payload;
  },
  [SET_PROJECTION_MODEL](state, payload) {
    state.projectionModel = payload;
  },

  async [SET_PROJECTION_API_RESPONSE](state, payload) {
    state.projectionAPIResponse = payload;
  },
  async [SET_INVESTMENT_CHART_MODEL](state, payload) {
    state.investmentChartModel = payload;
  },
  [SET_COMPARE_INVESTMENTS_INFO](state, payload) {
    state.compareInvestments = payload;
  },
};
